// extracted by mini-css-extract-plugin
module.exports = {"featuredText":"Title_featuredText__ZmXDy"};